import { useChain } from './useChain';

import { fallbackRollbackStackingConfig } from '../../dataAccessLayer/chain/constants';

export const useRollbackStackingConfig = () => {
  const chain = useChain();
  return chain?.attributes?.rollbackStackingConfig || fallbackRollbackStackingConfig;
};
